import { render, staticRenderFns } from "./adminTitle.vue?vue&type=template&id=36209752&scoped=true"
import script from "./adminTitle.vue?vue&type=script&lang=js"
export * from "./adminTitle.vue?vue&type=script&lang=js"
import style0 from "./adminTitle.vue?vue&type=style&index=0&id=36209752&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36209752",
  null
  
)

export default component.exports